export const STORAGE_KEY_PLAYBACK_RATE = 'OE-video-playback-rate';
const MIN_PLAYBACK_RATE = 0.25;
const MAX_PLAYBACK_RATE = 4;

export const getStoredPlaybackRate = (): number => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY_PLAYBACK_RATE);
        if (stored == null) return 1;
        const rate = parseFloat(stored);
        if (!Number.isFinite(rate) || rate < MIN_PLAYBACK_RATE || rate > MAX_PLAYBACK_RATE) return 1;
        return rate;
    } catch {
        return 1;
    }
};
